export const environment = {
  apiUrl: 'https://apinodehomol.ebarn.com.br/api',
  websocketUrl: 'https://apinodehomol.ebarn.com.br',
  /**
   * Link "Ver histórico completo" no histórico de compra do mapa. Liga quando o ebarn-node tiver
   * a rota do histórico do produto (ideias/historico-compras-produto.md). No localhost, sem a
   * rota, o link aparece mesmo desligado e o modal mostra dados de exemplo.
   */
  historicoComprasCompleto: false,
};
